import React from 'react';
import { animationTransition } from '@shared/utils/animationTransition';
import { Box, BoxProps, Flex } from '@withjoy/joykit';
import { pxToRem } from '@withjoy/joykit/theme';

const Dot = ({ isActive }: { isActive?: boolean }) => {
  return (
    <Box
      width={pxToRem(8)}
      height={pxToRem(8)}
      borderRadius={'50%'}
      backgroundColor={isActive ? 'mono14' : 'mono3'}
      transition={animationTransition('background-color')}
    />
  );
};

interface StateIndicatorsProps extends BoxProps {
  activeIndex: number;
  numberOfDots: number;
}

export const StateIndicators = (props: StateIndicatorsProps) => {
  const { activeIndex, numberOfDots, ...boxProps } = props;
  return (
    <Flex
      gap={3}
      {...boxProps}
    >
      {Array.from({ length: numberOfDots }).map((_, index) => (
        <Dot
          key={index}
          isActive={index === activeIndex}
        />
      ))}
    </Flex>
  );
};
